// extracted by mini-css-extract-plugin
module.exports = {"numberColumn":"TrendTables-module_numberColumn__3XQs440-R83SOKDOdg6WHb"};